import correctIcon from '@/assets/paper-collect/correct-icon.png'
import correctDisabledIcon from '@/assets/paper-collect/correct-disabled-icon.png'
import failIcon from '@/assets/paper-collect/fail-icon.png'
import failDisabledIcon from '@/assets/paper-collect/fail-disabled-icon.png'

export const listeningMaterialAudioType = {
  uploadAudio: 1, //上传已有音频
  oneselfRecording: 2, // 自己录制音频
  synthesisAudio: 3 // 合成听力音频
}

export const paperType = {
  listening: 'LISTENING', // 听力题
  reading: 'READING', // 朗读题
  written: 'WRITTEN' // 笔试题
}

export const listeningMaterialType = {
  chapter: 'chapter', //篇章
  dialogue: 'dialogue' // 对话
}

export const smallQuestionTypeEnum = {
  judgment: 1, // 判断题
  singleChoose: 2, // 选择题
  wordReading: 3, //单词朗读
  sentenceReading: 4, // 句子朗读
  paragraphReading: 5, // 段落朗读
  multipleChoose: 6 // 多选题
}

// 选择类的小题题型
export const chooseSmallQuestionTypeList = [
  smallQuestionTypeEnum.judgment,
  smallQuestionTypeEnum.singleChoose,
  smallQuestionTypeEnum.multipleChoose
]

// 朗读类的小题题型
export const readSmallQuestionTypeList = [
  smallQuestionTypeEnum.wordReading,
  smallQuestionTypeEnum.sentenceReading,
  smallQuestionTypeEnum.paragraphReading
]

// 小题类型映射
export const smallQuestionTypeMap = {
  [smallQuestionTypeEnum.judgment]: {
    label: '判断',
    dtqLabel: '判断',
    value: smallQuestionTypeEnum.judgment
  },
  [smallQuestionTypeEnum.wordReading]: {
    label: '单词朗读',
    dtqLabel: '单词',
    value: smallQuestionTypeEnum.wordReading,
    evaluateType: 'en.word.score'
  },
  [smallQuestionTypeEnum.sentenceReading]: {
    label: '句子朗读',
    dtqLabel: '句子',
    value: smallQuestionTypeEnum.sentenceReading,
    evaluateType: 'en.sent.score'
  },
  [smallQuestionTypeEnum.paragraphReading]: {
    label: '短文',
    dtqLabel: '短文',
    value: smallQuestionTypeEnum.paragraphReading,
    evaluateType: 'en.pred.score'
  },
  [smallQuestionTypeEnum.singleChoose]: {
    label: '单选',
    dtqLabel: '单选',
    value: smallQuestionTypeEnum.singleChoose
  },
  [smallQuestionTypeEnum.multipleChoose]: {
    label: '多选',
    dtqLabel: '多选',
    value: smallQuestionTypeEnum.multipleChoose
  }
}

export const smallQuestionType = {
  [smallQuestionTypeEnum.singleChoose]: {
    label: '单选',
    value: smallQuestionTypeEnum.singleChoose
  },
  [smallQuestionTypeEnum.multipleChoose]: {
    label: '多选',
    value: smallQuestionTypeEnum.multipleChoose
  }
}

export const smallQuestionReadingType = {
  [smallQuestionTypeEnum.wordReading]: {
    label: '单词',
    value: smallQuestionTypeEnum.wordReading
  },
  [smallQuestionTypeEnum.sentenceReading]: {
    label: '句子',
    value: smallQuestionTypeEnum.sentenceReading
  },
  [smallQuestionTypeEnum.paragraphReading]: {
    label: '短文',
    value: smallQuestionTypeEnum.paragraphReading
  }
}

export const smallQuestionTypeList = Object.entries(smallQuestionType).map(([k, v]) => ({
  label: v.label,
  value: v.value
}))

export const smallQuestionReadingList = Object.entries(smallQuestionReadingType).map(([k, v]) => ({
  label: v.label,
  value: v.value
}))

export const judgeList = ['√', '×']
export const judgeMap = {
  '√': {
    normalIcon: correctIcon,
    disabledIcon: correctDisabledIcon
  },
  '×': {
    normalIcon: failIcon,
    disabledIcon: failDisabledIcon
  }
}
export const judgeTextMap = {
  E: '√',
  F: '×'
}

// 显示模式
export const displayModeMap = {
  // 套卷模式
  exam: 'exam',
  // 单题模式
  single: 'single'
}

// 作答状态
export const answerStateMap = {
  // 初始化
  init: 1,
  // 作答中
  answering: 2,
  // 作答结束
  answerEnd: 3
}

// 答案对应的色值
export const answerColorMap = {
  // 未设置答案
  null: {
    bgColor: '#E8F1FF',
    color: '#1976FF'
  },
  // 正确答案
  true: {
    bgColor: '#E8F9EF',
    color: '#1DC060'
  },
  // 错误答案
  false: {
    bgColor: '#FFEBEA',
    color: '#FF3C30'
  }
}
